import { render, staticRenderFns } from "./extra-settings.vue?vue&type=template&id=129359b0"
import script from "./extra-settings.vue?vue&type=script&lang=js"
export * from "./extra-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports